import produce from 'immer';

import moment from 'moment';
import {
  SESSIONLOG_LIST,
  SESSIONLOG_LIST_REQUEST, SESSIONLOG_PAGE_RESET,
  SET_SESSIONLOG_PAGINATION, SET_TOTAL_COUNT
} from '../../constants/log/sessionLogConstants';

const initialState = {
  page: 1,
  pageLength: 10,
  beginDate: moment().utc().subtract(3, 'days').format('YYYY-MM-DDT00:00:00'),
  endDate: moment().utc().format('YYYY-MM-DDT23:59:59'),
  searchString: '',
  totalCount: 0,
};

const sessionLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case SESSIONLOG_LIST_REQUEST:
      break;
    case SESSIONLOG_LIST:
      draft.list = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_SESSIONLOG_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.beginDate = action.beginDate;
      draft.endDate = action.endDate;
      draft.searchString = action.searchString;
      break;
    case SESSIONLOG_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default sessionLogReducer;
